import { useEffect } from 'react';

// global.css locks document scrolling (`body { overflow: hidden }`) because the
// admin layout scrolls inside its own containers. Public pages scroll the
// document itself, so re-enable it while the page is mounted — without this,
// content below the fold (e.g. the Register button on mobile) is unreachable.
export function usePublicPageScroll() {
  useEffect(() => {
    document.body.classList.add('public-scroll');
    return () => document.body.classList.remove('public-scroll');
  }, []);
}
